import { UsersStatisticsResDto } from 'types/swagger';
import { breakpoint } from 'utility/constant';
import styles from './LegendContent.module.scss';
import { useBarChartHooks } from '../../useBarChartHooks';
import { useTypedSelector } from 'lib/centralStore';
import useWindowSize, { enComparer } from 'hooks/useWindowSize';

export interface LegendContentProps {
  data?: Array<UsersStatisticsResDto>;
}

export const LegendContent = ({ data }: LegendContentProps) => {
  const { doCheck } = useWindowSize();

  const [isMobile] = doCheck([{ comparer: enComparer.less | enComparer.equal, size: breakpoint.sm }]);

  const { chartColors } = useBarChartHooks();

  return (
    <ul className={`${isMobile ? styles.legendMobile : styles.legendList}`}>
      {data?.map((entry, index) => (
        <li key={`item-${index}`} style={{ color: chartColors[index] }}>
          <div>
            <svg width="4" height="12" viewBox="0 0 4 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.6" d="M0 0H4V27H0V0Z" fill={chartColors[index]} />
            </svg>
            <span>
              <div className={styles.legendTitle}>{entry.verticale}</div>
            </span>
          </div>
        </li>
      ))}
    </ul>
  );
};
